module.exports = __webpack_public_path__ + "img/20191204172807684.7531fe10.jpg";